export class CaasIdType {
  static readonly SEOURL = 'page.formData.pt_seoUrl.value'
  static readonly PAGEID = 'identifier'
  static readonly PIM_IDENTIFIER = 'page.formData.pt_pimIdentifier.value'
  static readonly CATEGORY = 'page.formData.pt_category_id.value.identifier'
}
